/* ORDINELLE — minimal vanilla enhancements. No user-facing copy lives here. */
(function () {
  'use strict';
  /* Sticky mobile purchase bar: reveal once the main buy button scrolls away. */
  function initStickyBar() {
    var bar = document.querySelector('[data-ord-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('[data-ord-buybox]');
    if (!anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }
  /* Accordion: allow only one open FAQ item per group (native <details> keeps a11y). */
  function initFaq() {
    document.querySelectorAll('[data-ord-faq]').forEach(function (group) {
      var items = group.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });
  }
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () { initStickyBar(); initFaq(); });
})();
